import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
// Components
import MovieHero from './MovieHero';
import MovieStats from './MovieStats';
import Cast from './Cast';
import StatusMessage from './StatusMessage';
import Button from './Button';
// Hooks
import { useMovieFetch } from '../hooks/useMovieFetch';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const Loading = styled.div`
  height: 70vh;
  background: var(--night);
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-family: var(--font-display);
    font-style: italic;
    font-weight: 800;
    font-size: 64px;
    color: var(--on-night);
    animation: pulse 1.2s ease-in-out infinite;

    em {
      color: var(--accent);
    }
  }

  @keyframes pulse {
    50% {
      opacity: 0.3;
    }
  }
`;

const Movie = () => {
  const { movieId } = useParams();
  const { state: movie, loading, error, retry } = useMovieFetch(movieId);

  useDocumentTitle(movie ? movie.title : error ? 'Movie not found' : '');

  if (error)
    return (
      <StatusMessage
        glyph='404'
        title='This reel is missing.'
        action={
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button text='Try again' callback={retry} variant='ghost' />
            <Button text='Browse movies' to='/' />
          </div>
        }
      >
        We couldn’t find a movie with that ID, or the database didn’t respond.
      </StatusMessage>
    );

  if (loading || !movie)
    return (
      <Loading role='status' aria-label='Loading movie'>
        <span>
          A<em>z</em>
        </span>
      </Loading>
    );

  return (
    <>
      <MovieHero movie={movie} />
      <MovieStats movie={movie} />
      <Cast actors={movie.actors} />
    </>
  );
};

export default Movie;
